import PropTypes from 'prop-types'
import React from 'react'
import { Checkbox, CheckboxGroup } from 'components/styled/checkbox'
import { Control } from 'react-redux-form'
import { useStore } from 'react-redux'

const propTypes = {
  field: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
      })
    ),
  }).isRequired,
  noValidation: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  fieldResponse: PropTypes.shape({
    answer: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string)
    ]),
  }),
}

const defaultProps = {
  fieldResponse: undefined,
}

const groupPropTypes = {
  componentProps: PropTypes.shape({
    field: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      fieldSetup: PropTypes.shape({ required: PropTypes.bool }).isRequired,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string,
        })
      ),
    }).isRequired,
    fieldResponse: PropTypes.shape({
      answer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
      ]),
    }),
  }),
  onChange: PropTypes.func.isRequired,
}

const CheckboxGroupComponent = ({ componentProps, onChange }) => {
  const { field, fieldResponse } = componentProps

  return (
    <CheckboxGroup useGrid>
      {field.options.map(option => (
        <Checkbox
          key={`${field._id}-${option.value}`}
          id={`${field._id}-${option.value}`}
          value={
            fieldResponse &&
            fieldResponse.answer &&
            fieldResponse.answer.includes(option.value)
          }
          onChange={newValue => {
            const oldAnswers = fieldResponse?.answer || []
            let newValueArray
            if (!newValue) {
              newValueArray = oldAnswers.filter(value => value !== option.value)
            } else {
              newValueArray = [...oldAnswers, option.value]
            }
            onChange(newValueArray)
          }}
          label={option.label}
        />
      ))}
    </CheckboxGroup>
  )
}

CheckboxGroupComponent.propTypes = groupPropTypes

export function CheckboxField({
  field,
  noValidation,
  onChange,
  fieldResponse,
}) {
  const store = useStore()
  return (
    <div id={field._id}>
      <Control
        store={store}
        model={`.${field._id}[]`}
        validators={
          field.fieldSetup.required && !noValidation
            ? { isRequired: value => value.length }
            : null
        }
        component={CheckboxGroupComponent}
        onChange={value => onChange(value)}
        componentProps={{
          field,
          fieldResponse,
        }}
      />
    </div>
  )
}

CheckboxField.propTypes = propTypes
CheckboxField.defaultProps = defaultProps

export default CheckboxField
